import { useEffect, useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Features from "@/pages/home/components/Features";
import HotShows from "@/pages/home/components/HotShows";
import NewReleases from "@/pages/home/components/NewReleases";
import Categories from "@/pages/home/components/Categories";
import Guide from "@/pages/home/components/Guide";
import Quality from "@/pages/home/components/Quality";
import Schedule from "@/pages/home/components/Schedule";
import Faq from "@/pages/home/components/Faq";
import CtaBand from "@/pages/home/components/CtaBand";
import Footer from "@/pages/home/components/Footer";
import { useReveal } from "@/hooks/useReveal";

export default function Home() {
  useReveal();
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero />
        <Features />
        <HotShows />
        <NewReleases />
        <Categories />
        <Guide />
        <Quality />
        <Schedule />
        <Faq />
        <CtaBand />
      </main>
      <Footer />

      {showTop ? (
        <button
          type="button"
          aria-label="回到页面顶部"
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      ) : null}
    </div>
  );
}